import React, { memo, forwardRef } from "react";
const SvgCapitalBeta = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12.376 9.992v5.184h3.096c.976 0 1.776-.216 2.4-.648.624-.448.936-1.112.936-1.992 0-1.696-1.24-2.544-3.72-2.544h-2.712zm0 7.2v5.784h2.976c.752 0 1.424-.08 2.016-.24a3.292 3.292 0 001.536-.912c.448-.464.672-1.056.672-1.776 0-1.904-1.336-2.856-4.008-2.856h-3.192zm3.216 7.8h-4.176c-.944 0-1.416-.472-1.416-1.416V9.416C10 8.472 10.472 8 11.416 8h4.44c1.472 0 2.728.344 3.768 1.032 1.04.688 1.56 1.776 1.56 3.264 0 .912-.272 1.696-.816 2.352-.528.656-1.248 1.104-2.16 1.344v.048c1.12.128 2.024.56 2.712 1.296.704.736 1.056 1.68 1.056 2.832 0 1.568-.6 2.768-1.8 3.6-1.184.816-2.712 1.224-4.584 1.224z"
      />
    </svg>
  );
});
SvgCapitalBeta.displayName = "SvgCapitalBeta";
const MemoForwardRef = memo(SvgCapitalBeta);
export default MemoForwardRef;
